import React from 'react';

const OnboardingMessage = () => (
  <div className="floating-toast-stack" aria-live="polite" aria-atomic="true">
    <div className="floating-toast floating-toast-warning" role="alert" aria-live="assertive">
      <div className="floating-toast-content">
        <strong>Onboarding Required</strong>
        <p>
          You do not have permission to upload factory files yet. Please contact your administrator or follow the onboarding process to gain access.
        </p>
      </div>
    </div>
  </div>
);

export default OnboardingMessage;
